module.exports = __webpack_public_path__ + "static/img/bg-id.a1996e27.png";